// Appends sizing/quality params for known stock-photo hosts so we don't ship
// full-resolution originals (often 1-3MB) for cards/thumbnails. Leaves
// unrecognized URLs untouched.
export function optimizeImageUrl(url, width = 800, quality = 75) {
  if (!url || typeof url !== 'string') return url;

  const [base, existingQuery] = url.split('?');
  const params = new URLSearchParams(existingQuery || '');

  if (url.includes('images.unsplash.com')) {
    params.set('auto', 'format');
    params.set('fit', 'crop');
    params.set('w', String(width));
    params.set('q', String(quality));
    return `${base}?${params.toString()}`;
  }

  if (url.includes('images.pexels.com')) {
    params.set('auto', 'compress');
    params.set('cs', 'tinysrgb');
    params.set('w', String(width));
    return `${base}?${params.toString()}`;
  }

  return url;
}
